import { Box, Card, Stack, Typography } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';
import { radius } from '@karehero/llama/theme/radius';

// An in-app toast announcing a newly published shortlist. Mirrors the
// notification row (icon in a tinted circle + title + body) as a floating card,
// so the in-app moment and the notification centre read as the same event.
// Presentational — the real one would slide in and auto-dismiss; here a caller
// positions it over the current screen.
const ShortlistToast = ({ title, body }: { title: string; body: string }) => (
  <Card sx={{ p: 1.5 }}>
    <Stack sx={{ alignItems: 'center' }} direction='row' spacing={1.5}>
      <Box
        sx={{
          flexShrink: 0,
          width: 40,
          height: 40,
          borderRadius: `${radius.xxl}px`,
          bgcolor: 'custom.limeGreen.100',
          color: 'custom.limeGreen.800',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon icon='magnifying-glass' fontSize={16} />
      </Box>

      <Stack sx={{ flex: 1, minWidth: 0 }} spacing={0.25}>
        <Typography variant='body1' noWrap>
          {title}
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          {body}
        </Typography>
      </Stack>

      <Box sx={{ flexShrink: 0, color: 'text.secondary', display: 'flex' }}>
        <Icon icon='chevron-right' fontSize={16} />
      </Box>
    </Stack>
  </Card>
);

ShortlistToast.displayName = 'ShortlistToast';
export default ShortlistToast;
